export enum InputFieldEnum {
    Default = 'default',
    Hovered = 'hovered',
    Focused = 'focused',
    Disabled = 'disabled',
    Error = 'error',
}
